import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { callPaymentHistory } from "../../../api/callcenters/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { handleGetCookie, FormatCurrencys } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import Swal from "sweetalert2";
import colors from '../../../utils/colors'
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import insuranceType from "../../../data/insuranceType"
import { callExportHistory } from "../../../api/export"
import SmartTable from "../../../components/common/table-component";

const Index = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [request, setRequest] = useState({
		page: 1, maxResult: 10, billNumber: '', contractNumber: '',
		modifiedCode: '', modifiedName: '', insuranceType: '', carriedCode: ''

	});
	const [paymentList, setPaymentList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);
	const [fromDate, setFromDate] = useState(null);
	const [toDate, setToDate] = useState(null);

	useEffect(() => {
		loadData();

		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				modifiedCode: authData?.user?.userId,
				modifiedName: authData?.user?.firstName + " " + (authData?.user?.lastName === null ? '' : authData?.user?.lastName),
			}));
		}

	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = {
			page: request.page,
			maxResult: request.maxResult,
			billNumber: request.billNumber,
			contractNumber: request.contractNumber,
			insuranceType: request.insuranceType,
			fromDate: fromDate,
			toDate: toDate,
			carriedCode: request.carriedCode
		};
		const rsp = await dispatch(callPaymentHistory(data));
		console.log(rsp)
		if (rsp?.payload?.responseCode === "00000") {
			setPaymentList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const downloadExcel = async () => {
		try {
			let data = {
				page: request.page,
				maxResult: totalRecord,
				billNumber: request.billNumber,
				contractNumber: request.contractNumber,
				insuranceType: request.insuranceType,
				fromDate: fromDate,
				toDate: toDate,
				carriedCode: request.carriedCode
			};
			let response = await callExportHistory(data);
			if (response === null) {
				Swal.fire(__t("uiText.text023"), __t("uiText.text025"), "error");
				return
			}
			const url = URL.createObjectURL(response);
			const link = document.createElement("a");
			link.href = url;
			link.download = __t("uiText.text178", { value1: moment().format("YYYYMMDDHHmmss") });
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error("❌ Error downloading Excel:", error);
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		// setRequest((prev) => ({ ...prev, billNumber: e.target.value }));
		const { name, value } = e.target;
		setRequest({
			...request,
			[name]: value,
		});
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData()
	}

	const selectInsuranceType = (e) => {
		setRequest((prev) => ({
			...prev,
			insuranceType: e.target.value,
		}));
	}

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.callcenter.history")}</h4>

						<div className="group-button-header">
							<button className="btn btn-success" onClick={downloadExcel}>
								<i className="fas fa-file-export"></i> {t("button.exportExcel")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="default-form">
											<div className="row">
												<div className="col-md-2 form-group">
													<label>{t('startDate')}</label>
													<DatePicker
														selected={fromDate}
														onChange={date => setFromDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('startDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('endDate')}</label>
													<DatePicker
														selected={toDate}
														onChange={date => setToDate(moment(date).format('YYYY-MM-DD'))}
														dateFormat="dd/MM/yyyy"
														placeholderText={t('endDate')}
														className="form-control-uld"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('callcenter.payment.insuranceType')}</label>
													<select className="chosen-single form-select"
														onChange={selectInsuranceType}
														value={request.insuranceType}
													>
														<option key={0} value={""}>{t("selectedAll")}</option>
														{
															insuranceType.map((item) => (
																<option key={item.id} value={item.id}>{t(item.name)}</option>
															))
														}
													</select>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('callcenter.payment.billNumber')}</label>
													<input
														type="text"
														name="billNumber"
														className="form-control-uld"
														placeholder={t('callcenter.payment.billNumber')}
														onChange={handleChange}
														value={request.billNumber}
														autoComplete="off"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('search.contractNumber')}</label>
													<input
														type="text"
														name="contractNumber"
														className="form-control-uld"
														placeholder={t('search.contractNumber')}
														onChange={handleChange}
														value={request.contractNumber}
														autoComplete="off"
													/>
												</div>

												<div className="col-md-2 form-group">
													<label>{t('callcenter.payment.carriedCode')}</label>
													<input
														type="text"
														name="carriedCode"
														className="form-control-uld"
														placeholder={t('callcenter.payment.carriedCode')}
														onChange={handleChange}
														value={request.carriedCode}
														autoComplete="off"
													/>
												</div>
											</div>

											<div className="row d-flex justify-content-center mt-2">
												<div className="col-auto auto-button">
													<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
														<i className="fas fa-search"></i>&nbsp;{t("button.search")}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
	columns={[
							{ labelKey: "callcenter.payment.id", key: "id" },
							{ labelKey: "callcenter.payment.billNumber", key: "billNumber" },
							{ labelKey: "callcenter.payment.channel", key: "channel" },
							{ labelKey: "callcenter.payment.carriedName", key: "carriedName" },
							{ labelKey: "callcenter.payment.createAt", key: "createAt", render: (val) => val ? moment(val).format("DD/MM/YYYY") : '-' },
							{ labelKey: "callcenter.payment.contractNumber", key: "contractNumber" },
							{ labelKey: "callcenter.payment.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('payments.status.paid')}</span> : <span className="badge bg-danger">{t('payments.status.notyet')}</span> },
							{ labelKey: "callcenter.payment.insuranceType", key: "insuranceTypeNameLa" },
							{ labelKey: "callcenter.payment.customerId", key: "customerId", render: (_, row) => row?.customer?.customerId || '-' },
							{ labelKey: "callcenter.payment.firstName", key: "firstName", render: (_, row) => row?.customer?.firstName || '-' },
							{ labelKey: "callcenter.payment.lastName", key: "lastName", render: (_, row) => row?.customer?.lastName || '-' },
							{ labelKey: "callcenter.payment.gender", key: "gender", render: (_, row) => row?.customer?.gender || '-' },
							{ labelKey: "callcenter.payment.reference1", key: "referenceNo_1" },
							{ labelKey: "callcenter.payment.reference2", key: "referenceNo_2" },
							{ labelKey: "callcenter.payment.civelLiability", key: "civelLiability", render: (val) => FormatCurrencys(val) || '-' },
							{ labelKey: "callcenter.payment.guaranteenFee", key: "guaranteenFee", render: (val) => FormatCurrencys(val) || '-' },
							{ labelKey: "callcenter.payment.monthTotal", key: "monthTotal" },
							{ labelKey: "callcenter.payment.packagePrice", key: "packagePrice", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.realPackageAmount", key: "realPackageAmount", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.registerFee", key: "registerFee", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.paymentFee", key: "paymentFee", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.discount", key: "discount", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.vatValue", key: "vatValue", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.commission", key: "commission", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.totalAmount", key: "totalAmount", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.companyReceiveTotal", key: "companyReceiveTotal", render: (val) => FormatCurrencys(val) },
							{ labelKey: "callcenter.payment.paidDate", key: "paidDate" },
						]}
	data={{ result: paymentList }}
	rowKey="id"
	recordsTableFilter={false}
	customPagination={false}
	showRowNumber={false}
/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
